const StatutoryBlock = ({ title, value }) => {
    return (
        <li className="md:p-5 p-2 border-b border-primary/10 last:border-b-0 border-solid">
            <div className="font-medium uppercase text-sm text-primary/80 tracking-wider mb-0.5">
                {title}
            </div>
            <p className="md:text-md text-sm">{value}</p>
        </li>
    );
};

export default StatutoryBlock;
